import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './Button';
const images = ['https://cdn.magicpatterns.com/uploads/6WzzbTArZWR7zeWksBXe88/IMG_9992.png', 'https://cdn.magicpatterns.com/uploads/mb9oVHDTqHPAum6Hkq8Js5/IMG_9991.png', 'https://cdn.magicpatterns.com/uploads/rCi4nYmuqiCwAtwJaCrP9h/IMG_9986.png', 'https://cdn.magicpatterns.com/uploads/7UR1co44yxfT8B28gyE5AU/IMG_9987.png'];
export function CarouselSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  return <section className="py-24 px-4 bg-warmwhite" data-id="element-52" data-mp="1va6tdbtpo65d">
      <div className="max-w-4xl mx-auto text-center" data-id="element-53" data-mp="3s5urbchbxuv3">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-green mb-2" data-id="element-54" data-mp="yich43x5tic">
          Mirá lo que hay adentro
        </h2>
        <p className="text-lg text-slate mb-12" data-id="element-55" data-mp="1u9po7jf0jk4g">
          Páginas reales del material — sin filtros, sin retoque. Deslizá para
          ver el contenido real del pack.
        </p>

        <div className="relative bg-cream p-4 md:p-8 rounded-3xl mb-12 shadow-sm border border-cream-dark" data-id="element-56" data-mp="1kj4v2bi3z7sx">
          <div className="aspect-[3/4] md:aspect-[4/3] relative overflow-hidden rounded-xl bg-white shadow-inner" data-id="element-57" data-mp="1giuds2ov8uyr">
            <AnimatePresence mode="wait" data-id="element-58" data-mp="2d79333o5jwys">
              <motion.img key={currentIndex} src={images[currentIndex]} initial={{
              opacity: 0,
              x: 100
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -100
            }} transition={{
              duration: 0.3
            }} className="absolute inset-0 w-full h-full object-contain" alt={`Página de muestra ${currentIndex + 1}`} data-id="element-59" data-mp="2d5xzp4ymcr87" />
            </AnimatePresence>
          </div>

          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 md:-translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-green hover:bg-cream transition-colors z-10 border border-cream-dark" data-id="element-60" data-mp="u8umpu8hfdkb">
            <ChevronLeft size={24} data-id="element-61" data-mp="6hyqmkwztw79" />
          </button>
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 md:translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-green hover:bg-cream transition-colors z-10 border border-cream-dark" data-id="element-62" data-mp="bbthc8b0nbfu">
            <ChevronRight size={24} data-id="element-63" data-mp="3jrmp9yra7ela" />
          </button>

          <div className="flex justify-center gap-2 mt-6" data-id="element-64" data-mp="3opoel1fawa57">
            {images.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === currentIndex ? 'bg-green' : 'bg-cream-dark'}`} data-id="element-65" data-mp="353v01sbg150k" data-mpi={i} />)}
          </div>
        </div>

        <Button href="#pricing" variant="green" data-id="element-66" data-mp="3e2ggnhxcu9yp">
          QUIERO MI MEGA PACK AHORA
        </Button>
      </div>
    </section>;
}